import { render, staticRenderFns } from "./AssetsLibModal.vue?vue&type=template&id=64c6f16f"
import script from "./AssetsLibModal.vue?vue&type=script&lang=js"
export * from "./AssetsLibModal.vue?vue&type=script&lang=js"
import style0 from "./AssetsLibModal.vue?vue&type=style&index=0&id=64c6f16f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports